<template>
  <div>
    <div>
      <template v-if="radio == '1'">
        <!-- label="統一售價" -->
        <el-form-item
          :label="language('promotionRules.unifiedPrice')"
          prop="reduce_assgned"
        >
          <div class="input">
            <el-input
              v-model="form.reduce_assgned"
              @input="input_num"
              type="number"
            ></el-input>
          </div>
        </el-form-item>
      </template>

      <template v-if="radio == '2'">
        <!-- label="統一折扣" -->
        <el-form-item
          :label="language('promotionRules.unifiedDiscount')"
          prop="reduce_direct_discount"
        >
          <div class="input">
            <el-input
              v-model="form.reduce_direct_discount"
              :min="1"
              :max="10"
              @input="inputDiscount"
              type="number"
            ></el-input>
            <el-alert
              :title="language('promotionRules.discountTips')"
               :closable="false"
            ></el-alert>
          </div>
        </el-form-item>
      </template>
      <!-- label="購買數量" -->
      <el-form-item
        :label="language('promotionRules.purchaseQuantity')"
        prop="target_order_num"
      >
        <div class="input">
          <el-input
            v-model="form.target_order_num"
            @input="inputTarget_order_num"
            type="number"
          ></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
export default {
  components: {},

  props: {
    formData: Object,
  },
  data() {
    return {
      radio: "1",
      form: {
        reduce_assgned: "",
        target_order_num: "",
        reduce_direct_discount: "",
        activityRuleList: [
          {
            activityRuleList: [
              {
                groupCode: "reduce",
                groupName: "扣減規則",
                ruleCode: "reduce_assgned", //reduce_assgned 統一售價 //target_order_num購買數量  //reduce_direct_discount  折扣
                status: 0,
                values: "",
              },
              {
                groupCode: "order",
                groupName: "订单限制",
                ruleCode: "target_order_num", //reduce_assgned 統一售價 //target_order_num購買數量  //reduce_direct_discount  折扣
                status: 0,
                values: "",
              },
            ],
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        let data = {
          activityRuleList: [
            {
              activityRuleList: [
                // {
                //   groupCode: "reduce",
                //   groupName: "扣減規則",
                //   ruleCode: "reduce_assgned", //reduce_assgned 統一售價 //target_order_num購買數量
                //   status: 0,
                //   values: this.form.reduce_assgned * 100,
                // },
                {
                  groupCode: "order",
                  groupName: "订单限制",
                  ruleCode: "target_order_num", //reduce_assgned 統一售價 //target_order_num購買數量
                  status: 0,
                  values: this.form.target_order_num,
                },
              ],
            },
          ],
        };
        if (this.radio == "1") {
          data.activityRuleList[0].activityRuleList.push({
            groupCode: "reduce",
            groupName: "扣減規則",
            ruleCode: "reduce_assgned",
            status: 0,
            values: (this.form.reduce_assgned * 1000) / 10,
          });
        } else {
          data.activityRuleList[0].activityRuleList.push({
            groupCode: "reduce",
            groupName: "扣減規則",
            ruleCode: "reduce_direct_discount",
            status: 0,
            values: this.form.reduce_direct_discount,
          });
        }
        data.reduce_assgned = this.form.reduce_assgned;
        data.reduce_direct_discount = this.form.reduce_direct_discount;
        data.target_order_num = this.form.target_order_num;

        if (this.form.reduce_assgned != "" && this.form.reduce_assgned == 0) {
          this.$alert(
            this.language("promotionRules.reduce_assgnedAlert"),
            this.language("promotionRules.tips"),
            {
              confirmButtonText: this.language("promotionRules.confirm"),
              callback: (action) => {},
            }
          );
        }

        if (
          this.form.reduce_direct_discount != "" &&
          this.form.reduce_direct_discount == 0
        ) {
          this.$alert(
            this.language("promotionRules.reduce_direct_discountAlert"),
            this.language("promotionRules.tips"),
            {
              confirmButtonText: this.language("promotionRules.confirm"),
              callback: (action) => {},
            }
          );
        }

        console.log(this.form, 11111);
        this.$emit("change", data);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    inputDiscount(value) {
      // if (value > 10) {
      //   this.form.reduce_direct_discount = 10;
      // }
      // if (value < 0) {
      //   this.form.reduce_direct_discount = 0;
      // }
      // return value;

      if (value > 10 || value < 0 || isNaN(value)) {
        this.$alert(
          this.language("promotionRules.checkDiscountTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.form.reduce_direct_discount = "";
            },
          }
        );
      }
    },
    inputTarget_order_num(value) {
      if (value < 0 || isNaN(value)) {
        this.$alert(
          this.language("promotionRules.checkQuantityTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.form.target_order_num = "";
            },
          }
        );
      }
      if (value > 0) {
        this.form.target_order_num = Math.floor(value);
      }
    },
    input_num(value) {
      if (value < 0 || isNaN(value)) {
        this.$alert(
          this.language("promotionRules.checkPriceTips"),
          this.language("common.tips"),
          {
            confirmButtonText: this.language("common.confirm"),
            callback: (action) => {
              this.form.reduce_assgned = "";
            },
          }
        );
      }
      if (value > 0) {
        // this.form.reduce_assgned = Math.floor(value);
        this.form.reduce_assgned = value;
      }
    },
  },
  mounted() {
    this.radio = this.formData.type;
    if (this.formData.activityRuleList) {
      let activityRuleList = this.formData.activityRuleList[0].activityRuleList;
      for (let i = 0; i < activityRuleList.length; i++) {
        if (activityRuleList[i].ruleCode == "reduce_direct_discount") {
          this.form["reduce_direct_discount"] = activityRuleList[i].values;
        } else if (activityRuleList[i].ruleCode == "reduce_assgned") {
          this.form["reduce_assgned"] = activityRuleList[i].values / 100;
        } else if (activityRuleList[i].ruleCode == "target_order_num") {
          this.form["target_order_num"] = activityRuleList[i].values;
        }
      }
    }
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
.group {
  margin-bottom: 20px;
}
</style>
